import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditPage = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-1 -1 22 22",
	stroke: "currentColor",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.74196 1.03857L6.003 1.03857C2.928 1.03857 1 3.21557 1 6.29757L1 14.6116C1 17.6936 2.919 19.8706 6.003 19.8706L14.827 19.8706C17.912 19.8706 19.831 17.6936 19.831 14.6116L19.831 10.5836",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.07763 9.17047L14.5506 1.6975C15.4816 0.7675 16.9906 0.7675 17.9216 1.6975L19.1386 2.9145C20.0696 3.8455 20.0696 5.3555 19.1386 6.2855L11.6296 13.7945C11.2226 14.2015 10.6706 14.4305 10.0946 14.4305H6.34863L6.44263 10.6505C6.45663 10.0945 6.68363 9.56447 7.07763 9.17047Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4141 2.85211L17.9801 7.41811",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgEditPage;
